__webpack_require__.p = "https://dev.app.avtar.ai/";